<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m615.537-448 75.999 69.307v45.384H502.692v220.614L480-90.004l-22.692-22.691v-220.614H268.464v-45.384L340.001-448v-326.615h-47.307v-45.384h370.151v45.384h-47.308V-448Zm-285.69 69.307h295.845l-55.538-52.692v-343.23H385.385v343.23l-55.538 52.692Zm147.922 0Z"/></svg>
</template>
